// Base mobules
export { default as Load } from './modules/Load';
export { default as CookieConsent } from './modules/CookieConsent';
export { default as Scroll } from './modules/Scroll';
// export { default as ParallaxSpeed } from './modules/ParallaxSpeed';
export { default as ClassToggle } from './modules/ClassToggle';
export { default as GLightbox } from './modules/GLightbox';
export { default as ImageParallax } from './modules/ImageParallax';
export { default as Modal } from './modules/Modal';
export { default as PopupModal } from './modules/PopupModal';
export { default as Slider } from './modules/Slider';
export { default as FoldVideo } from './modules/FoldVideo';
export { default as SplitWords } from './modules/SplitWords';
export { default as SplitLines } from './modules/SplitLines';
export { default as FlexibleFormsV2 } from './modules/FlexibleFormsV2';
export { default as ContactForm } from './modules/ContactForm';
export { default as Accordion } from './modules/Accordion';
export { default as Testimonials } from './modules/Testimonials';
export { default as CursorChange } from './modules/CursorChange';
export { default as FollowCursor } from './modules/FollowCursor';
export { default as CircleShape } from './modules/CircleShape';

// export { default as Navs } from './modules/Navs';
// export { default as NavAnchors } from './modules/NavAnchors';

// Accessibility Navigation modules
// export { default as Accessibility } from './modules/Accessibility';
// export { default as AccessibilityNav } from './modules/AccessibilityNav';
// export { default as SetFocus } from './modules/SetFocus';

// Addons modules
export { default as Tabs } from './modules/Tabs';
export { default as ShowMore } from './modules/ShowMore';
// export { default as Figcaption } from './modules/Figcaption';
// export { default as MouseCursor } from './modules/MouseCursor';
// export { default as BFSlider } from './modules/BFSlider';
// export { default as FileLabel } from './modules/FileLabel';
// Video play on safari / iphone
// export { default as Video } from './modules/Video';
// export { default as FormValidation } from './modules/FormValidation';